import React from 'react';
import instagram from '../../images/icons/instagram.svg';
import soundcloud from '../../images/icons/soundcloud.svg';

export default function Socials() {
    const socials = [
      {
        title: 'Instagram',
        slug: 'instagram',
        svg: instagram,
        href:'https://www.instagram.com/dehayez/',
        id: 1
      },
      {
        title: 'Soundcloud',
        slug: 'soundcloud',
        svg: soundcloud,
        href:'https://soundcloud.com/dehayez',
        id: 2
      },
    ];

    const socialItems = socials.map(social =>
        <a className={`social-item social-item--${social.slug}`} key={social.id} href={social.href} aria-label={`Dehayez on ${social.title}`} target="_blank" rel="noopener noreferrer">
          <span className="social-item__tooltip">{social.title}</span>
          <img className='social-item__image' src={social.svg} alt=""></img>
        </a>
    );
    return (
        <nav className='social-items' aria-label="Social media">{socialItems}</nav>
    )
}
